import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.operations.title',
    defaultMessage: 'Manage Operations',
  },
});

function AdminOperationsPage() {
  const { formatMessage } = useIntl();

  return (
    <AdminManagement.Layout title={formatMessage(messages.title)}>
      <AdminManagement.Operations.List />
    </AdminManagement.Layout>
  );
}

export default AdminOperationsPage;
